export default {
  SET_LIST_ORDER (state, orders) {
    state.orders = orders
    state.loading = false
  },
  SET_LIST_CUSTOM_STATUS (state, statuses) {
    state.customStatuses = (statuses || []).filter(status => status.is_published).map(status => ({ ...status, visible: false }))
    state.loading = false
  },
  SET_LOADING_ORDER (state, loading) {
    state.loading = loading
  }
}
